"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServer = (typeof window === 'undefined' || typeof document === 'undefined');
exports.isClient = !exports.isServer;



//////////////////
// WEBPACK FOOTER
// ./~/@shopify/react-utilities/target.js
// module id = ./node_modules/@shopify/react-utilities/target.js
// module chunks = 0